import './WaitLayer.css';
import { Box, Typography, CircularProgress, CircularProgressProps } from '@mui/material';

function CircularProgressWithLabel(props: CircularProgressProps & { value: number }) {
    return (
        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
            <CircularProgress
                variant='determinate'
                {...props}
            />
            <Box
                sx={{
                    top: 0,
                    left: 0,
                    bottom: 0,
                    right: 0,
                    position: 'absolute',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Typography
                    variant='caption'
                    component='div'
                    color='text.secondary'
                >{`${Math.round(props.value)}%`}</Typography>
            </Box>
        </Box>
    );
}

interface WaitLayerProps {
    progress?: number;
    component?: boolean; // Parent position should be relative for this prop and it should also have a minimum height!
    small?: boolean;
}

const WaitLayer = (props: WaitLayerProps) => {
    const progress =
        props.progress != undefined && props.progress >= 0 && props.progress <= 100
            ? props.progress
            : null;

    return (
        <div className={'Wait-box' + (props.component ? '--componentWrapper' : '')}>
            <div className='center-box'>
                {progress && <CircularProgressWithLabel value={progress} />}
                {!progress && (
                    <CircularProgress
                        style={{
                            width: props.small ? 30 : 40,
                            height: props.small ? 30 : 40
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default WaitLayer;
